import React from 'react';

export default function BarraFiltros({ children, onSubmit, acoes, rotulo = 'Filtros' }) {
  const Container = onSubmit ? 'form' : 'div';

  return (
    <Container className="routine-filterbar" role="search" aria-label={rotulo} onSubmit={onSubmit}>
      {children}
      {acoes && <div className="routine-filterbar__actions">{acoes}</div>}
    </Container>
  );
}

export function BotaoConsultar({ disabled = false }) {
  return (
    <button type="submit" className="routine-btn routine-btn--primary" disabled={disabled}>
      <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="10.5" cy="10.5" r="6.5" />
        <path d="m16 16 5 5" />
      </svg>
      Consultar
    </button>
  );
}
